import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { REDUCER_NAME } from './slice';

export const getRoot = prop([REDUCER_NAME]);
export const getProductionControlDetail = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'detail'));
export const getProductionControlDetailNotices = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'detailNotices'));
export const getFinalStates = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'finalStates'));
export const getDetailViewed = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'detailViewed'));
